export default "<app-header *ngIf=\"userAuthenticaded\"></app-header>\n<app-navbar *ngIf=\"userAuthenticaded\"></app-navbar>\n<router-outlet></router-outlet>\n"